import backgroundLeftSide from 'ud-ui/components/images/background-left-side.png';
import backgroundRightSide from 'ud-ui/components/images/background-right-side.png';
import sizes from 'modules/application-link/domain/constants/sizes';
import useMediaQuery from 'shared/hooks/use-media-query';

const Background: React.FC = () => {
  const isMobile = useMediaQuery(`(max-width: ${sizes.mobile.WIDTH}px)`);

  if (isMobile) return null;

  return (
    <>
      <img style={{ position: 'absolute', top: 0, left: 0, height: '100%', zIndex: 0 }} src={backgroundLeftSide} alt="background" />
      <img style={{ position: 'absolute', top: 0, right: 0, height: '100%', zIndex: 0 }} src={backgroundRightSide} alt="background" />
    </>
  );
};

export default Background;
